import { render, staticRenderFns } from "./NewKeFu.vue?vue&type=template&id=d0052056&scoped=true"
import script from "./NewKeFu.vue?vue&type=script&lang=js"
export * from "./NewKeFu.vue?vue&type=script&lang=js"
import style0 from "./NewKeFu.vue?vue&type=style&index=0&id=d0052056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0052056",
  null
  
)

export default component.exports